
const numberFormatter = (key, value, model, record, translate) => {
    const formatter = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 4 });
    return formatter.format(value);
};



export default numberFormatter;